import { createOnboardingStore } from './create-onboarding-store';

const useCorporateStore = createOnboardingStore('kyb_corporate_draft', 5);

export { useCorporateStore };
